<script>
    import "./partnersLogo.css"
    let partnersLogo = [
        {
            logo: "./images/partners-logo/zkspace.png",
            alt: "zkspace",
        },
        {
            logo: "./images/partners-logo/chain.png",
            alt: "chain",
        },
        {
            logo: "./images/partners-logo/polygon.png",
            alt: "polygon",
        },
        {
            logo: "./images/partners-logo/allianceblock.png",
            alt: "allianceblock",
        },
        {
            logo: "./images/partners-logo/tv.svg",
            alt: "tv",
        },
        {
            logo: "./images/partners-logo/seascape.png",
            alt: "seascape",
        },
        {
            logo: "./images/partners-logo/spore.png",
            alt: "spore",
        },
        {
            logo: "./images/partners-logo/igg.png",
            alt: "igg",
        },
        {
            logo: "./images/partners-logo/mgg.png",
            alt: "mgg",
        },
        {
            logo: "./images/partners-logo/crypto.png",
            alt: "crypto",
        },
        {
            logo: "./images/partners-logo/kawai.png",
            alt: "kawai",
        },
        // {
        //     logo: "./images/partners-logo/steller-gate.png",
        //     alt: "steller-gate",
        // },
        {
            logo: "./images/partners-logo/nitro.svg",
            alt: "nitro",
        },
        {
            logo: "./images/partners-logo/gladian.png",
            alt: "gladian",
        },
        {
            logo: "./images/partners-logo/dafi.png",
            alt: "dafi",
        },
        {
            logo: "./images/partners-logo/core.png",
            alt: "core",
        },
        {
            logo: "./images/partners-logo/polygen.png",
            alt: "polygen",
        },
        {
            logo: "./images/partners-logo/game-rich.png",
            alt: "game-rich",
        },
        {
            logo: "./images/partners-logo/polkalokr.png",
            alt: "polkalokr",
        },
        {
            logo: "./images/partners-logo/router.png",
            alt: "router",
        },
        {
            logo: "./images/partners-logo/royale.png",
            alt: "royale",
        },
        {
            logo: "./images/partners-logo/nftplay.png",
            alt: "nftplay",
        },
        {
            logo: "./images/partners-logo/coinfantasy.png",
            alt: "coinfantasy",
        },
        {
            logo: "./images/partners-logo/artwallet.png",
            alt: "artwallet",
        },
        {
            logo: "./images/partners-logo/bulliverse.png",
            alt: "bulliverse",
        },
        {
            logo: "./images/partners-logo/gemie.png",
            alt: "gemie",
        },
        {
            logo: "./images/partners-logo/shark-race.png",
            alt: "shark-race",
        },
        {
            logo: "./images/partners-logo/remnant-lab.png",
            alt: "remnant-lab",
        },
    ];
</script>
<div class="partners-section">
    <div class="container">
        <h2 class="text-center">Partners</h2>
        <div class="flex flex-wrap justify-center">
            {#each partnersLogo as image, index}
            <div class="logo flex items-center flex-text-center">
                <img src={image.logo} alt={image.alt} />
            </div>
            {/each}
        </div>
    </div>
</div>